import React from 'react';
import { Modal } from 'react-bootstrap';

const getOrdinal = (d) => {
  const day = Number(d);
  if (!day) return '';
  if (day % 10 === 1 && day % 100 !== 11) return 'st';
  if (day % 10 === 2 && day % 100 !== 12) return 'nd';
  if (day % 10 === 3 && day % 100 !== 13) return 'rd';
  return 'th';
};

const OrganizationalMetricsModal = ({
  show,
  onHide,
  data,
  title,
  date,
  cardType
}) => {
  // Default data structure matching the Figma design
  const tableData = data.map(item => ({
    metricsName: item.metricsName,
    riskLevel: item.riskLevel
  }));

  // Enforce showing only entries matching the clicked cardType
  const filteredTableData = tableData.filter(item => item.riskLevel === cardType);


  // Format date with ordinal (e.g., 13th August 2025)
  let formattedDate = date;
  // if (date) {
  //   const d = new Date(date);
  //   const day = d.getDate();
  //   const suffix = getOrdinal(day);
  //   const month = d.toLocaleString('en-GB', { month: 'long' });
  //   const year = d.getFullYear();
  //   formattedDate = `${day}${suffix} ${month} ${year}`;
  // } else {
  //   // Default to current date formatted
  //   const today = new Date();
  //   const day = today.getDate();
  //   const suffix = getOrdinal(day);
  //   const month = today.toLocaleString('en-GB', { month: 'long' });
  //   const year = today.getFullYear();
  //   formattedDate = `${day}${suffix} ${month} ${year}`;
  // }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="organizational-metrics-modal-title"
      centered
      className="metrics-modal"
    >
      <div className="metrics-modal-header">
        <div className="metrics-modal-header-content">
          <h5 className="metrics-modal-title">{title}</h5>
          <div className="metrics-modal-date">
            <img src="/assets/icons/calendar.svg" alt="Calendar" className="w-h-16" />
            <span>{formattedDate}</span>
          </div>
        </div>
      </div>

      <Modal.Body className="metrics-modal-body">
        <div className="metrics-modal-table-wrapper">
          <table className="metrics-modal-table">
            <thead>
              <tr>
                <th className="risk-header">Risk Level</th>
                <th className="metrics-header">Metrics</th>
              </tr>
            </thead>
            <tbody>
              {filteredTableData.length > 0 ? (
                filteredTableData.map((item, index) => (
                  <tr key={index} className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                    <td className="risk-cell">
                      <div className={`metrics-risk-badge ${item.riskLevel}`}>
                        {item.riskLevel === 'green' ? 'Green' : item.riskLevel === 'amber' ? 'Amber' : 'Red'}
                      </div>
                    </td>
                    <td className="metrics-cell">
                      <span className="text-axis fw-500 text-16">{item.metricsName}</span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center text-muted py-4">
                    No Records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OrganizationalMetricsModal;
